<div
  class="w-full max-w-360 mx-auto px-gutter py-1 md:px-container-padding md:py-1"
>
  <!-- Left Side: Main Timer Area -->
  <div
    class="w-full max-w-xl mx-auto bg-surface-container-low border border-outline-variant rounded-xl p-gutter relative overflow-hidden transition-all duration-700"
    [class.bg-error-container]="status() === 'running' && segment() === 'work'"
    [class.bg-primary-container]="
      status() === 'running' && segment() === 'rest'
    "
  >
    <div class="relative z-10 flex flex-col items-center gap-1 text-center">
      <div class="flex">
        <app-jkcheckbox
          class="self-start"
          label="啟用蕃茄鐘"
          #MA015Com
          id="MA015"
          [value]="pomodoroEnabled()"
          (valueChange)="setPomodoroEnabled($event)"
        >
        </app-jkcheckbox>
        <app-jkcheckbox
          class="self-start"
          label="設定"
          [value]="showSetup()"
          (valueChange)="showSetup.set($event)"
        >
        </app-jkcheckbox>
      </div>
      <div
        class="text-[30px] md:text-[30px] tabular-nums font-bold tracking-tighter text-on-surface leading-none"
      >
        {{ displayTime() }}
      </div>
      <mat-toolbar class="h-auto! min-h-0! flex w-full justify-center gap-3">
        @if (status() === "ready" || status() === "waiting") {
          <button
            class="btn-primary"
            [disabled]="!pomodoroEnabled()"
            (click)="start()"
          >
            {{ startLabel() }}
          </button>
        } @else {
          <button class="btn-warning" (click)="togglePause()">
            {{ status() === "paused" ? "繼續" : "暫停" }}
          </button>
          <button class="btn-info" (click)="reset()">重置</button>
        }
      </mat-toolbar>
      @if (showSetup()) {
        <div class="flex flex-nowrap items-center justify-center gap-x-4">
          <label class="m-0! inline-flex items-center gap-1">
            專注
            <input
              class="w-16 bg-surface rounded border border-outline-variant px-1 py-0.5 text-center"
              type="number"
              min="1"
              max="120"
              [ngModel]="workMinutes()"
              (ngModelChange)="setWorkMinutes($event)"
            />
            分
          </label>
          <label class="m-0! inline-flex items-center gap-1">
            休息
            <input
              class="w-16 bg-surface rounded border border-outline-variant px-1 py-0.5 text-center"
              type="number"
              min="1"
              max="120"
              [ngModel]="restMinutes()"
              (ngModelChange)="setRestMinutes($event)"
            />
            分
          </label>
        </div>
      }
    </div>

    <!-- Pulse Effect Background (Conditional) -->
    <!--     @if (status() === "running" || status() === "waiting") {
      <div
        class="absolute inset-0 flex items-center justify-center pointer-events-none opacity-50 transition-opacity duration-1000"
      >
        <div
          class="w-75 h-75 rounded-full timer-pulse mix-blend-screen"
          [style.background]="
            segment() === 'work'
              ? 'radial-gradient(circle, rgba(182, 4, 14, 0.15) 0%, rgba(182, 4, 14, 0) 70%)'
              : 'radial-gradient(circle, rgba(0, 91, 193, 0.15) 0%, rgba(0, 91, 193, 0) 70%)'
          "
        ></div>
      </div>
    }
 -->
  </div>
</div>
